<div class="mx-5">
  <mat-select [disabled]="recordsManager.isLoading" (selectionChange)="onSelectionChange($event)" [value]="sizes[0]"
    color="accent" class="accent-text">
    <mat-option *ngFor="let size of sizes" [value]="size" color="accent" >
      {{utils.traslatei18n('ROWS_PER_PAGE')}}: {{size}}
    </mat-option>
  </mat-select>

</div>